// covered-by: frontends/carrie/src/ask-v2/review/__tests__/useAskV2ReviewSidebarAutoCollapse.test.ts
import { useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import { setDrawerOpen } from "../../utils/slices/ui";

/**
 * Collapse the app nav sidebar when a V2 review workspace opens so the
 * artwork pane can use the full viewport width.
 */
export function useAskV2ReviewSidebarAutoCollapse(isReviewOpen: boolean) {
  const dispatch = useAppDispatch();
  const sidebarOpen = useAppSelector((state) => state.ui.drawerOpen.app);
  const prevReviewOpenRef = useRef(false);

  useEffect(() => {
    if (isReviewOpen && !prevReviewOpenRef.current && sidebarOpen) {
      dispatch(setDrawerOpen({ app: false }));
    }
    prevReviewOpenRef.current = isReviewOpen;
  }, [dispatch, isReviewOpen, sidebarOpen]);
}
